import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../../../elements/Box';
import Text from '../../../elements/Text';

const FareItemTripDuration = (props) => {
  const {
    flightDeltaDays,
    tripDurationLabelKey,
    tripDurationSameDayLabelKey,
    singularLabel,
    tripDurationSingularLabelKey,
    id
  } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Box className={`fare-item-trip-duration ${className}`} style={style} id={id}>
      {flightDeltaDays > 0 ? (
        <>
          <Text dataTestId="stay-length" floatLeft>
            {flightDeltaDays}
          </Text>
          <Text floatLeft marginLeft="1">
            {singularLabel && flightDeltaDays === 1
              ? translate(tripDurationSingularLabelKey, 'trip day')
              : translate(tripDurationLabelKey, 'trip days')}
          </Text>
        </>
      ) : (
        <Text floatLeft>{translate(tripDurationSameDayLabelKey, 'Trip on the same day')}</Text>
      )}
    </Box>
  );
};

FareItemTripDuration.propTypes = {
  /**
   * Duration of trip.
   */
  singularLabel: PropTypes.bool,
  flightDeltaDays: PropTypes.number,
  tripDurationSingularLabelKey: PropTypes.string,
  tripDurationLabelKey: PropTypes.string,
  tripDurationSameDayLabelKey: PropTypes.string
};
FareItemTripDuration.defaultProps = {
  singularLabel: false,
  flightDeltaDays: null,
  tripDurationLabelKey: 'cmp-trip-duration-text-label',
  tripDurationSingularLabelKey: 'cmp-trip-duration-text-singular-label',
  tripDurationSameDayLabelKey: 'cmp-trip-duration-same-day-text-label'
};

FareItemTripDuration.componentName = 'FareItemTripDuration';

export default FareItemTripDuration;
